import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Image } from "primereact/image";
import sampleTyreImage from "../../assets/images/sample_tyre.png";
import carSuvImg from "../../assets/images/car_suv.png";
import bikeImg from "../../assets/images/bike_scooter.png";
import threeWheelerImg from "../../assets/images/three_wheeler.png";
import commercialImg from "../../assets/images/commercial.png";
import { Product } from "../Product/Product";
import ceatMini from "../../assets/images/TyreBrandLogos/ceat_mini.png";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { setTabIndex } from "../../redux/tabIndexSlice";
import useHeroAPI from "../../api/useHeroAPI";
import useProductsAPI from "../../api/useProductsAPI";
import { useNavigate } from "react-router-dom";
import { selectCity } from "../../redux/citySlice";
import { selectRefreshTrigger } from "../../redux/productSlice";
import PunctureKit from "../../pages/PunctureKit/PunctureKit";

const PopularProducts = (props: any) => {
  const { code } = props;
  const basePath = process.env.REACT_APP_BASE_PATH;

  const refreshTrigger = useSelector(selectRefreshTrigger);

  const cityId = useSelector(selectCity);
  const tabIndex = useSelector((state: RootState) => state.tabIndex);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { predefinedFunc } = useHeroAPI();
  const { getProductList } = useProductsAPI();

  const [popularProductsArray, setPopularProductsArray] = useState([]) as any;
  const [userId, setUserId] = useState(null) as any;
  const [productType, setProductType] = useState({} as any);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [tyreType, setTyreType] = useState(null) as any;
  const [typesPreDefinedState, setTypesPreDefinedState] = useState([]);

  useEffect(() => {
    window.scrollTo(0, scrollPosition);
  }, [scrollPosition]);

  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
    if (authTokens?.user?.id) {
      setUserId(authTokens?.user?.id);
    }
  }, []);

  // const fetchPredefined = async (parentId: number) => {
  // const predefinedParentPayload = {
  //   entity_type: "CATEGORY",
  //   categoryParentID: parentId,
  // };

  // const predefinedResponse = await predefinedFunc(predefinedParentPayload);
  // if (predefinedResponse.status === 200) {
  //   setTypesPreDefinedState(predefinedResponse?.data?.data);
  //   const defaultTyreType = predefinedResponse?.data?.data?.find(
  //     (type: any) => type?.code === "TWO-WHEELER",
  //   );
  //   setTyreType(defaultTyreType);

  //   const twoWheelerIndex = predefinedResponse?.data?.data.findIndex(
  //     (type: any) => type.code === "TWO-WHEELER",
  //   );
  //   if (twoWheelerIndex !== -1) {
  //     dispatch(setTabIndex(twoWheelerIndex));
  //   }
  // }
  // fetchChildPredefined();
  // };
  const fetchPredefined = async (parentId: number) => {
    const predefinedParentPayload = {
      entity_type: "CATEGORY",
      categoryParentID: parentId,
    };

    const predefinedResponse = await predefinedFunc(predefinedParentPayload);
    if (predefinedResponse.status === 200) {
      setTypesPreDefinedState(predefinedResponse?.data?.data);

      if (code !== "PUNCTURE KIT") {
        const defaultTyreType = predefinedResponse?.data?.data?.find(
          (type: any) => type?.code === "TWO-WHEELER",
        );
        setTyreType(defaultTyreType);

        const twoWheelerIndex = predefinedResponse?.data?.data.findIndex(
          (type: any) => type?.code === "TWO-WHEELER",
        );
        if (twoWheelerIndex !== -1) {
          dispatch(setTabIndex(twoWheelerIndex));
        }
      }
    }
  };

  const fetchProductType = async (code: string) => {
    const predefinedParentPayload = {
      entity_type: "PRODUCT-TYPE",
      code: code,
    };
    const predefinedResponse = await predefinedFunc(predefinedParentPayload);

    if (predefinedResponse.status === 200) {
      setProductType(predefinedResponse?.data?.data[0]);
      productListFunc(predefinedResponse?.data?.data[0]?.predefined_id);
      fetchPredefined(predefinedResponse?.data?.data[0]?.predefined_id);
    }
  };
  const productListFunc = async (product_type: number) => {
    const isPunctureKit = code === "PUNCTURE KIT";
    const payload = {
      entity_type: isPunctureKit ? "" : "POPULAR",
      // city_id: cityId ? cityId : null,
      page_size: isPunctureKit ? 100 : 6,
      page_number: 1,
      user_id: userId,
      product_type_id: product_type,
      // category_ids: tyreType?.predefined_id ? [tyreType.predefined_id] : null,
      category_ids: isPunctureKit
        ? null
        : tyreType?.predefined_id
          ? [tyreType.predefined_id]
          : null,
    };

    const response: any = await getProductList(payload);
    if (response?.status === 200 || response?.status === 201) {
      setPopularProductsArray(response?.data);
    }
  };

  // useEffect(() => {
  //   // if(userId){
  //   fetchPredefined();
  //   fetchProductType(code);
  //   // }
  // }, [userId, code]);
  useEffect(() => {
    if (!code) return;

    fetchProductType(code);
  }, [userId, code]);
  useEffect(() => {
    if (
      productType?.predefined_id &&
      (code === "PUNCTURE KIT" || tyreType?.predefined_id)
    ) {
      productListFunc(productType.predefined_id);
    }
  }, [productType, tyreType, refreshTrigger]);

  // const [tabIndex, setTabIndex] = useState(0);
  const [popularProdsTabIndex, setPopularProdsTabIndex] = useState(0);

  const handlePopularProdsTabSelect = (
    index?: any,
    last?: any,
    event?: any,
  ) => {
    event?.preventDefault();
    event?.stopPropagation();
    const newVehicleType: any = typesPreDefinedState[index];
    // setTyreType((event.target as Element).textContent);
    setTyreType(newVehicleType);
    setScrollPosition(window.pageYOffset);
    dispatch(setTabIndex(index));
  };

  // useEffect(() => {
  //   handlePopularProdsTabSelect(tabIndex, null, null);
  // }, [tabIndex]);
  useEffect(() => {
    if (code === "PUNCTURE KIT") {
      if (tabIndex !== 0) dispatch(setTabIndex(0));
      return;
    }
    handlePopularProdsTabSelect(tabIndex, null, null);
  }, [tabIndex, code]);

  // const handlePopularProdsTabSelect = (index: number) => {
  //   setPopularProdsTabIndex(index);
  // };

  const predefinedImgArr = [carSuvImg, bikeImg, threeWheelerImg, commercialImg];

  const redirectToProducts = () => {
    // navigate("/mechmiles-customer/products");
    navigate(`${basePath}products`, {
      state: {
        code: code,
        type_id: productType.predefined_id,
        tyreType: tyreType,
        productType: productType,
      },
    });
  };
  return (
    <>
      <div className="popular-products-title">
        {code === "PUNCTURE KIT" ? "Puncture kit products" : "Popular products"}
      </div>
      <Container className="popular-products-tab">
        {/* <Tabs selectedIndex={tabIndex} onSelect={handlePopularProdsTabSelect}> */}
        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index: any, lastIndex: number, event: Event) =>
            handlePopularProdsTabSelect(index, lastIndex, event)
          }
        >
          {code !== "PUNCTURE KIT" && (
            <TabList>
              <div className="internal-popular-products-tab flex w-full justify-content-center align-item-center margin-bottom-20px">
                <div>
                  {typesPreDefinedState.map((types: any, index: number) => (
                    <Tab key={index}>
                      <Image
                        src={
                          tabIndex === index
                            ? types?.active_thumbnail
                            : types?.thumbnail
                        }
                        className="tyre-type-images"
                      />
                      {types.name}
                    </Tab>
                  ))}
                </div>
              </div>
            </TabList>
          )}

          <TabPanel>
            <div className="product-container">
              <div className="product-wrapper">
                {popularProductsArray?.map((product: any, index: any) => (
                  <Product key={index} product={product} />
                ))}
              </div>

              {code !== "PUNCTURE KIT" && (
                <div className="view-all-wrapper">
                  <span className="view-all-btn" onClick={redirectToProducts}>
                    View All
                  </span>
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="product-container">
              <div className="product-wrapper">
                {popularProductsArray?.map((product: any, index: any) => (
                  <Product key={index} product={product} />
                ))}
              </div>
              <div className="view-all-wrapper" onClick={redirectToProducts}>
                <span className="view-all-btn">View All</span>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="product-container">
              <div className="product-wrapper">
                {popularProductsArray?.map((product: any, index: any) => (
                  <Product key={index} product={product} />
                ))}
              </div>
              <div className="view-all-wrapper">
                <span className="view-all-btn">View All</span>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="product-container">
              <div className="product-wrapper">
                {popularProductsArray?.map((product: any, index: any) => (
                  <Product key={index} product={product} />
                ))}
              </div>
              <div className="view-all-wrapper">
                <span className="view-all-btn">View All</span>
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </Container>
    </>
  );
};

export default PopularProducts;
